import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="w-full bg-background-950 text-background-200 py-12 md:py-16 px-6 md:px-10">
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 md:gap-10 mb-10">
          <div className="md:col-span-1">
            <span className="font-heading text-xl font-semibold text-background-50 tracking-tight">
              Sugargoo<span className="text-primary-400">Sheet</span>
            </span>
            <p className="text-sm text-background-400 mt-3 leading-relaxed">
              The ultimate Sugargoo Spreadsheet database and shopping guide. Helping global shoppers discover, compare and understand Sugargoo products.
            </p>
            <p className="text-xs text-background-500 mt-4 italic">
              Independent educational resource. We do not sell products directly.
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">Guides</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/sugargoo-spreadsheet-guide" className="text-sm text-background-400 hover:text-background-100 transition-colors duration-200 cursor-pointer whitespace-nowrap" onClick={() => { window.scrollTo({ top: 0, behavior: 'smooth' }); }}>
                  Spreadsheet Guide
                </Link>
              </li>
              <li>
                <Link to="/sugargoo-shopping-guide" className="text-sm text-background-400 hover:text-background-100 transition-colors duration-200 cursor-pointer whitespace-nowrap" onClick={() => { window.scrollTo({ top: 0, behavior: 'smooth' }); }}>
                  Shopping Guide
                </Link>
              </li>
              <li>
                <Link to="/sugargoo-shipping-guide" className="text-sm text-background-400 hover:text-background-100 transition-colors duration-200 cursor-pointer whitespace-nowrap" onClick={() => { window.scrollTo({ top: 0, behavior: 'smooth' }); }}>
                  Shipping Guide
                </Link>
              </li>
              <li>
                <Link to="/sugargoo-warehouse" className="text-sm text-background-400 hover:text-background-100 transition-colors duration-200 cursor-pointer whitespace-nowrap" onClick={() => { window.scrollTo({ top: 0, behavior: 'smooth' }); }}>
                  Warehouse Guide
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">Reviews & Savings</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/sugargoo-review" className="text-sm text-background-400 hover:text-background-100 transition-colors duration-200 cursor-pointer whitespace-nowrap" onClick={() => { window.scrollTo({ top: 0, behavior: 'smooth' }); }}>
                  Sugargoo Review
                </Link>
              </li>
              <li>
                <Link to="/sugargoo-legit" className="text-sm text-background-400 hover:text-background-100 transition-colors duration-200 cursor-pointer whitespace-nowrap" onClick={() => { window.scrollTo({ top: 0, behavior: 'smooth' }); }}>
                  Is Sugargoo Legit?
                </Link>
              </li>
              <li>
                <Link to="/sugargoo-coupon" className="text-sm text-background-400 hover:text-background-100 transition-colors duration-200 cursor-pointer whitespace-nowrap" onClick={() => { window.scrollTo({ top: 0, behavior: 'smooth' }); }}>
                  Coupon Codes
                </Link>
              </li>
              <li>
                <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-background-400 hover:text-background-100 transition-colors duration-200 cursor-pointer whitespace-nowrap">
                  Main Website <i className="ri-external-link-line w-3 h-3 inline-flex items-center justify-center ml-0.5"></i>
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">Legal</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/privacy-policy" className="text-sm text-background-400 hover:text-background-100 transition-colors duration-200 cursor-pointer whitespace-nowrap" onClick={() => { window.scrollTo({ top: 0, behavior: 'smooth' }); }}>
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/terms-of-service" className="text-sm text-background-400 hover:text-background-100 transition-colors duration-200 cursor-pointer whitespace-nowrap" onClick={() => { window.scrollTo({ top: 0, behavior: 'smooth' }); }}>
                  Terms of Service
                </Link>
              </li>
              <li>
                <Link to="/privacy-policy" className="text-sm text-background-400 hover:text-background-100 transition-colors duration-200 cursor-pointer whitespace-nowrap" onClick={() => { window.scrollTo({ top: 0, behavior: 'smooth' }); }}>
                  Disclaimer
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-background-800 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; {currentYear} Sugargoo Sheet. All rights reserved. Independent educational resource.
          </p>
          <div className="flex items-center gap-5">
            <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-background-500 hover:text-background-200 transition-colors duration-200 cursor-pointer">
              <i className="ri-global-line text-lg"></i>
            </a>
            <span className="text-xs text-background-600">Proudly independent</span>
          </div>
        </div>
      </div>
    </footer>
  );
}